<template>
	<!--
    	作者：luoyiming
    	时间：2019-10-26
    	描述：商品管理-商品编辑-基础信息
    -->
	<div class="basic-setting-content pl16 pr16">
		<!--基本信息-->
		<el-form-item label="技师名称：">
			<el-input v-model="form.waiter.username" class="max-w460"></el-input>
		</el-form-item>
		<el-form-item label="技师艺名：" prop="waiter.nickname">
			<el-input v-model="form.waiter.nickname" class="max-w460"></el-input>
		</el-form-item>
		<el-form-item label="接单电话">
			<el-input class="max-w460" v-model="form.waiter.mobile"></el-input>
		</el-form-item>
		<el-form-item label="接单电话">
			<el-input class="max-w460" v-model="form.waiter.mobile"></el-input>
		</el-form-item>
		<el-form-item label="紧急联系人">
			<el-input class="max-w460" v-model="form.waiter.contactName"></el-input>
		</el-form-item>
		<el-form-item label="紧急联系电话">
			<el-input class="max-w460" v-model="form.waiter.contactMobile"></el-input>
		</el-form-item>
		<el-form-item label="工作时长">
			<el-input class="max-w460" placeholder="请输入工作时长" v-model="form.waiter.workingHours">
				<template slot="append">年</template>
			</el-input>
		</el-form-item>
		<el-form-item label="是否虚拟技师">
			<el-select v-model="form.waiter.isVirtual" placeholder="请选择" @change="change">
				<el-option label="正常技师" :value="0"></el-option>
				<el-option label="虚拟技师" :value="1"></el-option>
			</el-select>
		</el-form-item>
		
		<el-form-item label="是否新人">
			<el-select v-model="form.waiter.isXr" placeholder="请选择" @change="change">
				<el-option label="否" :value="0"></el-option>
				<el-option label="是" :value="1"></el-option>
			</el-select>
		</el-form-item>
		<el-form-item label="是否推荐">
			<el-select v-model="form.waiter.isTj" placeholder="请选择" @change="change">
				<el-option label="否" :value="0"></el-option>
				<el-option label="是" :value="1"></el-option>
			</el-select>
		</el-form-item>
		<!-- <el-form-item label="所属城市">
      <el-select v-model="form.waiter.city_id" placeholder="请选择" @change="change">
        <el-option v-for="(item, index) in form.service_city" :key="index" :label="item.city" :value="item.city_id">
        </el-option>
      </el-select>
    </el-form-item> -->
		<!-- <el-form-item label="所属商户">
			<el-select v-model="form.waiter.merchantId" placeholder="请选择">
				<el-option v-for="(item, index) in form.supplier" :key="index" :label="item.name"
					:value="item.shopSupplierId">
				</el-option>
			</el-select>
		</el-form-item> -->
		<el-form-item label="虚拟订单量">
			<el-input class="max-w460" v-model="form.waiter.virtualOrder"></el-input>
		</el-form-item>
		<Upload v-if="isProductUpload" :config="config" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">
			上传图片
		</Upload>
	</div>
</template>

<script>
	import Technician from "@/api/technician.js";
	import DataApi from "@/api/data.js";
	import Upload from "@/components/file/Upload";
	import draggable from "vuedraggable";
	export default {
		props: ['isDisabled'],
		components: {
			Upload,
			draggable
		},
		data() {
			return {
				isProductUpload: false,
				config: {},
				file_name: "image",
				areaList: []
			};
		},
		inject: ["form"],
		created() {
			console.log("==============form12331231", this.form);
		},

		methods: {
			change(val) {
				console.log("========eeee", val);
				this.form.waiter.city_id = val;
				console.log("========eee333e", this.form.waiter.city_id);
			},
			/*打开审核*/
			agreeclick(item) {
				this.userModel = deepClone(item);
				this.open_edit = true;
			},
			/*打开上传图片*/
			openProductUpload: function(fileType, file_name) {
				this.file_name = file_name;
				if (fileType == "image") {
					this.config = {
						total: 1,
						fileType: "image"
					};
				} else {
					this.config = {
						total: 1,
						fileType: "video"
					};
				}
				this.isProductUpload = true;
			},

			/*上传商品图片*/
			returnProductImgsFunc(e) {
				if (e != null) {
					if (this.file_name == "video") {
						this.form.waiter.video_id = e[0].fileId;
						this.form.waiter.video = e[0];
					} else if (this.file_name == "service_image") {
						this.form.auth.id_card_front = e[0].filePath;
					} else if (this.file_name == "group_image") {
						this.form.group_image = e[0].filePath;
					} else if (this.file_name == "mp_image") {
						this.form.mp_image = e[0].filePath;
					}
				}
				this.isProductUpload = false;
			},
			handleClose(tagItem) {
				this.form.waiter.tag.splice(this.form.waiter.tag.indexOf(tagItem), 1);
			},

			showInput() {
				this.inputVisible = true;
				this.$nextTick(_ => {
					this.$refs.saveTagInput.$refs.input.focus();
				});
			},

			handleInputConfirm() {
				let inputValue = this.inputValue;
				if (inputValue) {
					if (this.form.waiter.tag == null) {
						this.form.waiter.tag = [];
					}
					this.form.waiter.tag.push(inputValue);
				}
				this.inputVisible = false;
				this.inputValue = "";
			}
		}
	};
</script>

<style>
	.edit_container {
		font-family: "Avenir", Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		line-height: 20px;
		color: #2c3e50;
	}

	.ql-editor {
		height: 400px;
	}

	.draggable-list {
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
	}

	.draggable-list .wrapper>span {
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
	}

	.draggable-list .item {
		position: relative;
		width: 110px;
		height: 110px;
		margin-top: 10px;
		margin-right: 10px;
		border-radius: 8px;
		overflow: hidden;
		border: 1px solid #dddddd;
	}

	.draggable-list .delete-btn {
		position: absolute;
		top: 0;
		right: 0;
		width: 16px;
		height: 16px;
		background: red;
		line-height: 16px;
		font-size: 16px;
		color: #ffffff;
		display: none;
	}

	.draggable-list .item:hover .delete-btn {
		display: block;
	}

	.draggable-list .item img {
		position: absolute;
		top: 50%;
		left: 50%;
		-webkit-transform: translate(-50%, -50%);
		transform: translate(-50%, -50%);
		max-height: 100%;
		max-width: 100%;
	}

	.draggable-list .img-select {
		display: flex;
		justify-content: center;
		align-items: center;
		border: 1px dashed #dddddd;
		font-size: 30px;
	}

	.draggable-list .img-select i {
		color: #409eff;
	}

	.el-tag+.el-tag {
		margin-left: 10px;
	}

	.button-new-tag {
		margin-left: 10px;
		height: 32px;
		line-height: 30px;
		padding-top: 0;
		padding-bottom: 0;
	}

	.input-new-tag {
		width: 90px;
		margin-left: 10px;
		vertical-align: bottom;
	}
</style>


// WEBPACK FOOTER //
// src/views/technician/technicianlist/part/basic.vue